<div class="row" >
  <div class="col-md-4 login-left text-center p-5 primary-background" style="background-color:#009B4C;margin-right: -30px;color: #ffffff;min-height:100vh;">
      
  <p style="font-size: 30px;font-weight: bold;text-align: center;"><img
    src={{applogo}}
    alt="DOWC"
    class="dark-logo"
    style="width: 140px;"
  /> Claims</p>
      <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by click <a class="btn-link text-white" style="color: #fff;" href="/signup">here</a>. If you already have an account, please login to pick up where you left off.</p>
      <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link text-white" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you!</p> -->
      </div>  
  <div class="col-md-8 login-right text-center p-5" >
    <div class="p-3 title-case" style="font-weight:bold; text-transform:uppercase;font-size: 24px;">
      <img class="dark-logo" style="width: 150px;" src={{logo}} alt="DOWC"> <span class="mt-1">
      </span>
    </div>
  <div class="card-body form-items" *ngIf="signupForm && !regStatus">
    <form
      [formGroup]="signupForm"
      (ngSubmit)="signup()"
      class="form-horizontal form-material"
      id="signupForm"
      novalidate
    >
      <h3 class="box-title m-b-5 font-weight-bold">
        Sign Up Now
      </h3>
      <!-- <small class="hidden">Create your account with Claims</small> -->
      <div class="row">
        <div class="col-12 p-xl-0">
          <div class="form-group row ml-0 mr-0">
            <div
              class="form-group m-xl-0 col-12 col-xl-6 d-xl-flex align-items-center p-0"
            >
              <div class="col-12 col-xl-12">
                <app-form-error-wrapper
                  [control]="signupForm.controls['firstName']"
                  [controlName]="'Firstname'"
                  [apiErrorType]="'firstName'"
                >
                  <input
                    class="form-control"
                    type="text"
                    formControlName="firstName"
                    placeholder="First Name *"
                  />
                </app-form-error-wrapper>
                <!-- <input type="text" name="firstname" class="form-control" /> -->
              </div>
            </div>
            <div
              class="form-group m-xl-0 col-12 col-xl-6 d-xl-flex align-items-center p-0"
            >
              <div class="col-12 col-xl-12">
                <app-form-error-wrapper
                  [control]="signupForm.controls['lastName']"
                  [controlName]="'Lastname'"
                  [apiErrorType]="'lastName'"
                >
                  <input
                    class="form-control"
                    type="text"
                    formControlName="lastName"
                    placeholder="Last Name *"
                  />
                </app-form-error-wrapper>
                <!-- <input type="text" name="lastname" class="form-control" /> -->
              </div>
            </div>
          </div>         

          <div class="form-group d-xl-flex align-items-center">
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['address']"
                [controlName]="'Street Address'"
                [apiErrorType]="'address'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="address"
                  placeholder="Street Address *"
                />
              </app-form-error-wrapper>
              <!-- <input type="text" name="streetAddress" class="form-control" /> -->
            </div>
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['city']"
                [controlName]="'City'"
                [apiErrorType]="'city'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="city"
                  placeholder="City *"
                />
              </app-form-error-wrapper>
              <!-- <input type="text" name="city" class="form-control" /> -->
            </div>
          </div>
          <div class="form-group d-xl-flex align-items-center">
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['state']"
                [controlName]="'State'"
                [apiErrorType]="'state'"
              >
                <select
                  class="custom-select form-control"
                  formControlName="state"
                >
                  <option value="">Select State</option>
                  <option
                    *ngFor="let stat of states"
                    value="{{ stat.code }}"
                    >{{ stat.name }}</option
                  >
                </select>
              </app-form-error-wrapper>
            </div>
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['zipcode']"
                [controlName]="'zipcode'"
                [apiErrorType]="'zipcode'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="zipcode"
                  Placeholder="Zip *"
                  mask="00000"
                />
              </app-form-error-wrapper>
            </div>            
          </div>
          <!-- <div class="form-group d-xl-flex align-items-center">
            <div
              class="form-group m-xl-0 col-12 col-xl-6 align-items-center"
            >
              <app-form-error-wrapper
                [control]="signupForm.controls['email']"
                [controlName]="'Email'"
                [apiErrorType]="'email'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="email"
                  placeholder="Email *"
                />
              </app-form-error-wrapper>
            </div>
            <div
              class="form-group m-xl-0 col-12 col-xl-6 align-items-center"
            >
              <app-form-error-wrapper
                [control]="signupForm.controls['phone']"
                [controlName]="'Mobile No.'"
                [apiErrorType]="'phone'"
              >
                <input
                  class="form-control"
                  type="tel"
                  mask="000-000-0000"
                  formControlName="phone"
                  placeholder="Mobile *"
                />
              </app-form-error-wrapper>
            </div>
          </div> -->
          <div class="form-group d-xl-flex align-items-center">            
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['dealer']"
                [controlName]="'Dealer'"
                [apiErrorType]="'dealer'"
                [ngClass]="{'d-none' : signupForm.get('noDealer').value}"
              >
                <ng-template #rt let-r="result" let-t="term">
                  {{ r.name }}
                </ng-template>
                <input
                  class="form-control remove-validate"
                  type="text"
                  [ngbTypeahead]="dealers"
                  [inputFormatter]="formatter"
                  formControlName="dealer"
                  [resultTemplate]="rt"
                  autocomplete="off"
                  placeholder="Search and select Dealer"
                  name="dealer"
                  [required]="!signupForm.get('noDealer').value"
                />
              </app-form-error-wrapper>
              <app-form-error-wrapper
                [control]="signupForm.controls['dealerName']"
                [controlName]="'dealerName'"
                [apiErrorType]="'dealer'"
                [ngClass]="{'d-none' : !signupForm.get('noDealer').value}"
              >
               <input
                  class="form-control"
                  type="text"
                  formControlName="dealerName"
                  placeholder="Enter Dealer name *"
                  [required]="signupForm.get('noDealer').value"
                />
              </app-form-error-wrapper>
              
              <!-- (selectItem)="selectedItem($event)" <input type="hidden" name="dealerId" formControlName="dealerId" #dealerId /> -->
              <div class="custom-control custom-checkbox ">
                <input id="noDealer" class="custom-control-input" formControlName="noDealer" type="checkbox" [checked]="signupForm.get('noDealer').value"/>
                <label for="noDealer" class="custom-control-label pt-1 small">Dealer not in the list</label>
              </div>                
            </div>
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center login-dob">
              <app-form-error-wrapper
                [control]="signupForm.controls['usertype']"
                [controlName]="'usertype'"
                [apiErrorType]="'usertype'"
              >
                <select
                  class="custom-select form-control"
                  formControlName="usertype"
                  (change)="changeValidator()"
                >
                  <option value="">Select Role</option>
                  <option
                    *ngFor="let type of usertypes"
                    value="{{ type.val }}"
                    >{{ type.name }}</option
                  >
                </select>
              </app-form-error-wrapper>
            </div>
             <!-- <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center login-dob">
              <app-form-error-wrapper
                [control]="signupForm.controls['birthDate']"
                [controlName]="'DOB'"
                [apiErrorType]="'birthDate'"
              >
                <input
                  class="form-control remove-validate"
                  type="text"
                  ngbDatepicker
                  placeholder="DOB"
                  #d="ngbDatepicker"
                  formControlName="birthDate"
                  (click)="d.toggle()"
                  [readonly]="true"
                  [minDate]="{ year: 1900, month: 1, day: 1 }"
                  [maxDate]="{
                        year: utilService.getCurrentYear,
                        month: utilService.getCurrentMonth,
                        day: utilService.getCurrentDay
                  }"
                />
              </app-form-error-wrapper>
              <a
                class="ng2-smart-action ng2-smart-action-delete-delete cursor-pointer pos-abs datecancel"
                (click)="utilService.removeDate(signupForm, 'birthDate')"
                placement="left"
                ngbTooltip="Remove"
                *ngIf="signupForm.controls['birthDate'].value"
              >
                <i class="ti-close text-danger m-r-10"></i>
              </a>
            </div> -->
          </div>
          <!-- <div class="form-group d-xl-flex align-items-center" *ngIf="signupForm.get('usertype').value && signupForm.get('usertype').value=='contract_holder'">                   
            <div class="col-12 col-xl-12 p-ls-xl-0">
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio">
                  <input type="radio" id="onsite-yes" name="reimbursement" class="custom-control-input"
                    formControlName="reimbursement" [value]="0" checked/>
                  <label class="custom-control-label mr-2" for="onsite-yes"> I lost my key or my key is broken or malfunctioning, what do I do? Give claims contact information</label>
                </div>
                <div class="custom-control custom-radio">
                  <input type="radio" id="onsite-no" name="reimbursement" class="custom-control-input"
                    formControlName="reimbursement" [value]="1" />
                  <label class="custom-control-label mr-2" for="onsite-no">I replaced a broken or malfunctioning key, how do I get reimbursed?</label>
                </div>
              </div>
            </div>
          </div> -->
            <div class="form-group d-xl-flex align-items-center">
            <div
              class="form-group m-xl-0 col-12 col-xl-6 align-items-center"
            >
              <app-form-error-wrapper
                [control]="signupForm.controls['email']"
                [controlName]="'Email'"
                [apiErrorType]="'email'"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="email"
                  placeholder="Email *"
                  autocomplete="off"
                />
              </app-form-error-wrapper>
            </div>
            <div
              class="form-group m-xl-0 col-12 col-xl-6 align-items-center"
            >
              <app-form-error-wrapper
                [control]="signupForm.controls['phone']"
                [controlName]="'Mobile No.'"
                [apiErrorType]="'phone'"
              >
                <input
                  class="form-control"
                  type="tel"
                  mask="000-000-0000"
                  formControlName="phone"
                  placeholder="Mobile *"
                  autocomplete="off"
                />
              </app-form-error-wrapper>
            </div>
          </div>

          <div class="form-group d-xl-flex align-items-center">
            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['password']"
                [controlName]="'Password'"
                [apiErrorType]="'password'"
              >
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    class="form-control"
                    [type]="passwordTextType ? 'text' : 'password'"
                    formControlName="password"
                    placeholder="Password *"
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"
                    (click)="passwordTextType = !passwordTextType;"
                      ><i
                        class="fa"
                        [ngClass]="{
                          'fa-eye-slash': passwordTextType,
                          'fa-eye': !passwordTextType
                        }"
                      ></i
                    ></span>
                  </div>
                </div>
              </app-form-error-wrapper>
              <span
              class="error help-block text-danger mt-1 d-block small"
              *ngIf="signupForm.get('password').value && signupForm.get('password').invalid"
              >Password must have minimum one Lowercase, Uppercase, Numbers, Special characters and 8 characters length
            </span>
            </div>

            <div class="form-group m-xl-0 col-12 col-xl-6 align-items-center">
              <app-form-error-wrapper
                [control]="signupForm.controls['cPassword']"
                [controlName]="'Confirm Password'"
                [apiErrorType]="'cPassword'"
              >
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    class="form-control"
                    [type]="cPasswordTextType ? 'text' : 'password'"
                    formControlName="cPassword"
                    placeholder="Confirm Password *"
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer"
                    (click)="cPasswordTextType = !cPasswordTextType;"
                      ><i
                        class="fa"
                        [ngClass]="{
                          'fa-eye-slash': cPasswordTextType,
                          'fa-eye': !cPasswordTextType
                        }"
                      ></i
                    ></span>
                  </div>
                </div>
              </app-form-error-wrapper>
              <span
                class="error help-block text-danger mt-1 d-block small"
                *ngIf="
                  signupForm.get('cPassword').value &&
                  signupForm.get('password').value !==
                    signupForm.get('cPassword').value
                "
                >Password doesn't matched.</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-group m-t-2">
        <div class="col-xs-3">
          <button
            type="submit"
            [disabled]="signupForm.invalid || isLoading"
            class="btn btn-info waves-effect waves-light"
            >
            <app-button-loader
              [isLoading]="isLoading"
              [label]="'Sign Up'"
            ></app-button-loader>
          </button>
        </div>
      </div>
      <div class="form-group m-t-2">
        <div class="col-xs-3">
            Already have an account?
            <a
              class="text-info m-l-5"
              [routerLink]="['/login']"
              [queryParams]="queryParams"
            >
              <b>Sign In</b>
            </a>
        </div>
      </div>
    </form>
  </div>
  <div class="card-body text-center" *ngIf="regStatus">
    <h2>Thank you for signing up with us!</h2>
    <p style="font-size: 16px;text-align: center;">An activation link will be sent to your email. Please check your inbox and proceed to activate your account.</p>
    <p class="mpad-t-5" style="font-size: 16px;text-align: center;">Once done, you can proceed to <a class="btn-link text-info" style="color: #fff;" href='/login'>login</a>.
    </p>
  </div>
</div>
<div class="col-md-6 login-bottom text-center p-5 primary-background" style="background-color:#009B4C;margin-right: -30px;color: #ffffff;">
  <p style="font-size: 30px;font-weight: bold;text-align: center;">{{appname}} Claims</p>
      <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by clicking on the link below. If you already have an account, please login to pick up where you left off.</p>
     <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you!</p> -->
    </div>
</div>
